import React, { useState } from "react";

import { Rate as AntRate } from "antd";

import { generateRandomId } from "utils";

import { Icon, Tooltip } from "components";

/**
 *
 * @param dataTestId {string}
 * @param checked {boolean}
 * @param onChange
 * @param disabled
 * @param tooltipText
 * @param iconSize
 * @param colour
 * @returns {JSX.Element}
 * @constructor
 */
const Bookmark = ({ dataTestId, checked, onChange, disabled, tooltipText, iconSize, colour }) => {
  const [animating, setAnimating] = useState(false);

  const id = generateRandomId();

  const update = (v) => {
    onChange(v);
    if (disabled) return;

    if (v) {
      setAnimating(true);
      const icon = document.getElementById(id);

      const qty = Math.floor(Math.random() * 20) + 5;
      const group = [];

      const iconBurst = document.createElement("div");
      iconBurst.id = `${id}-siblings`;
      iconBurst.setAttribute("class", "icon-burst");
      iconBurst.style.top = `${icon.getBoundingClientRect().top + window.scrollY}px`;
      iconBurst.style.left = `${icon.getBoundingClientRect().left + window.scrollX}px`;
      document.body.appendChild(iconBurst);

      for (let i = 0; i < qty; i += 1) {
        const scale = Math.floor(Math.random() * 5) + 5;
        const x = Math.floor(Math.random() * 100) - 50;
        const y = Math.floor(Math.random() * 100) - 50;

        const newIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        newIcon.setAttribute("width", "24");
        newIcon.setAttribute("height", "24");
        newIcon.setAttribute("fill", colour);
        newIcon.style.transform = `scale(0.${scale})`;
        newIcon.innerHTML = '<path d="M9 4h6a2 2 0 0 1 2 2v14l-5 -3l-5 3v-14a2 2 0 0 1 2 -2" />';

        document.getElementById(`${id}-siblings`).appendChild(newIcon);

        group.push({
          shape: newIcon,
          x: x,
          y: y,
        });
      }

      setTimeout(() => {
        for (let a = 0; a < group.length; a += 1) {
          const { shape } = group[a];
          const { x } = group[a];
          const { y } = group[a];

          shape.style.left = x;
          shape.style.top = y;
          shape.style.transform = "scale(0)";
        }
      }, 100);

      setTimeout(() => {
        document.getElementById(`${id}-siblings`).remove();
        setAnimating(false);
      }, 1000);
    }
  };

  return (
    <AntRate
      data-testid={`${dataTestId}`}
      character={
        <Tooltip placement="bottom" title={tooltipText}>
          <Icon
            dataTestId={`${dataTestId}-icon`}
            iconName="tabler/bookmark"
            fill={checked ? colour : "white"}
            color={colour}
            className="icon bookmarked"
            size={iconSize}
            id={id}
          />
        </Tooltip>
      }
      count={1}
      defaultValue={checked}
      value={checked || animating ? 1 : 0}
      onChange={(v) => update(v)}
    />
  );
};

export { Bookmark };
